// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SpWfi","footer":"styles_footer__2Byqg","passCodeTooltip":"styles_passCodeTooltip__3KBkJ"};